<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.282"
    height="18.288"
    viewBox="0 0 18.282 18.288"
  >
    <g transform="translate(-0.095)">
      <path
        d="M152.072,244.307a1.61,1.61,0,0,1,1.072,1.515v.536h1.072v-.536a2.676,2.676,0,0,0-1.073-2.143,2.677,2.677,0,0,0,1.073-2.143V241h-1.072v.536a1.61,1.61,0,0,1-1.072,1.515V241H151v5.358h1.072Z"
        transform="translate(-145.515 -232.392)"
      />
      <path
        d="M272.607,246.358a1.609,1.609,0,0,0,1.607-1.607v-1.607h-1.607v1.072h.536v.536a.536.536,0,1,1-1.072,0v-2.143a.536.536,0,1,1,1.072,0h1.072a1.607,1.607,0,1,0-3.215,0v2.143A1.609,1.609,0,0,0,272.607,246.358Z"
        transform="translate(-261.228 -232.392)"
      />
      <path
        d="M9.236,0A2.682,2.682,0,0,0,6.557,2.679v.536H2.345L.095,18.288H18.377L16.127,3.215H11.915V2.679A2.682,2.682,0,0,0,9.236,0ZM7.628,2.679a1.607,1.607,0,0,1,3.215,0v.536H7.628ZM15.2,4.286l1.93,12.931H1.338L3.268,4.286Z"
      />
    </g>
  </svg>
</template>
